import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FlexView, Card, Link } from '../common'
import { downloadDocuments } from 'utils/documents'
import styled from 'styled-components'
import './Collapse.css'
import { RiArrowDownSLine } from 'react-icons/ri'
// import { UserContext } from 'stores/UserStore'
// import { TubularContext } from 'stores/TubularStore'
import { UserContext } from 'stores/UserStore'



const Collapse = ({ item, qty, nm, report, children, isExpand = false }, i) => {
  const [expand, setExpand] = useState(isExpand)
  const { t } = useTranslation()
  // const { getDocument, getDocumentDownloadURL } = useContext(TubularContext)
  const { idToken } = useContext(UserContext)
  const { registryLogOld, registryLog } = useContext(UserContext)
  // let result = false

  const CardCollapse = styled(Card)`
    color: #777777;
    border-radius: 4px;
    border: 1px solid #dddddd;
    padding: 8px 16px;
    margin:8px 0px 0px 8px;
  `
  const downloadDocument = (value, type, idToken) => {
    registryLogOld('download_cq', '/tlh/sot')
    registryLog('sot', 'download', 'quality_certificate')
    downloadDocuments(value, type, idToken, t)
    // if(result){
    //   // openDocument(result.data, 'teste')
    // }

    // // if (result) {
    // //   toast(t('tlh.noReport'))
    // // }
  }

  return (
    <CardCollapse index={i} width="95%" display="flex">
      <FlexView flexDirection="row" alignItems="center" justifyContent="space-between" alignSelf="stretch" style={{ cursor: 'pointer' }}>
        <FlexView flexDirection="row">
          <FlexView fontSize="medium" style={{ cursor: 'pointer', color: "rgb(119, 119, 119)" }}>
            {t('tlh.sot.item')}:
          </FlexView>
          <FlexView fontSize="medium" style={{ cursor: 'pointer', color: "rgb(48, 48, 48)", marginLeft: '5px' }}>
            {item}&nbsp;
          </FlexView>
        </FlexView>
        <FlexView flexDirection="row">
          <FlexView fontSize="medium" style={{ cursor: 'pointer', color: "rgb(119, 119, 119)" }} >
            {t('tlh.sot.nm')}:
          </FlexView>
          <FlexView fontSize="medium" style={{ cursor: 'pointer', color: "rgb(48, 48, 48)", marginLeft: '5px' }}>
            {nm}&nbsp;
          </FlexView>
        </FlexView>
        <FlexView flexDirection="row">
          <FlexView fontSize="medium" style={{ cursor: 'pointer', color: "rgb(119, 119, 119)" }} >
            &nbsp;&nbsp;{t('tlh.sot.qty')}:
          </FlexView>
          <FlexView fontSize="medium" style={{ cursor: 'pointer', color: "rgb(48, 48, 48)", marginLeft: '5px' }}>
            {qty}&nbsp;
          </FlexView>
        </FlexView>
        {
          report ?
            <FlexView fontSize="medium" style={{ display: 'inline', color: "rgb(119, 119, 119)" }}>
              {t('tlh.sot.report')}:
              <Link onClick={() => downloadDocument(report, 'inspection_report', idToken)} style={{ fontSize: 'medium', marginLeft: '2px' }}>
                {report} </Link>&nbsp;
            </FlexView>
            :
            <FlexView fontSize="medium" style={{ display: 'inline', cursor: 'pointer', color: "rgb(119, 119, 119)" }}>
              {t('tlh.sot.report')}: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </FlexView>
        }
        <RiArrowDownSLine onClick={() => setExpand(expand => !expand)} style={{ color:'#59CBE4' }} />
      </FlexView>
      <span className="icon"><i className={`fa fa-play-circle${!expand ? ' down' : ''}`}></i></span>
      <div className="clearfix"></div>
      {expand && <div className="content">{children}</div>}
    </CardCollapse>
  )
}

export default Collapse
